import React, { useContext, useState } from 'react';
import Form from '../../..';
import * as S from './styled';
import DateFilter from '../../../../DateFilter';
import { setFilterColumn } from '../../../../../store/utils';
import { ExportContext } from '../../../../../provider/ExportProvider';

export default function FormLogisticFilter() {
  const {
    getLogisticAutocompleteItems,
    getLogisticOriginAutocompleteItems,
    setLogisticAutocompleteItems,
    setLogisticOriginAutocompleteItems,
    getLogisticFilterField,
    getLogisticOriginFilterField,
    setLogisticField,
    setLogisticOriginField,
    setLogisticSearchFilter,
    setLogisticOriginSearchFilter,
    logisticSearchFilter,
    logisticOriginSearchFilter,
    setInvoice,
  } = useContext(ExportContext)!.controllers.logistic;

  const getLogisticItems = (field: keyof InvoiceState['autocompletes']['logistics']) =>
    getLogisticAutocompleteItems(field);

  const getLogisticOriginItems = (field: keyof InvoiceState['autocompletes']['logisticOrigins']) =>
    getLogisticOriginAutocompleteItems(field);

  const [companyLoading, setCompanyLoading] = useState(false);
  const [originInvoiceNumberLoading, setOriginInvoiceNumberLoading] = useState(false);
  const [nrcInvoiceNumberLoading, setNrcInvoiceNumberLoading] = useState(false);
  const [clientInvoiceNumberLoading, setClientInvoiceNumberLoading] = useState(false);
  const [crtLoading, setCrtLoading] = useState(false);

  const autocompleteCompanies = () => {
    setCompanyLoading(true);
    Promise.all([
      setLogisticAutocompleteItems('company'),
      setLogisticOriginAutocompleteItems('company')
    ])
      .finally(() => {
        setCompanyLoading(false);
      });
  };

  const autocompleteOriginInvoiceNumbers = () => {
    setOriginInvoiceNumberLoading(true);
    setLogisticOriginAutocompleteItems('originInvoiceNumber')
      .finally(() => {
        setOriginInvoiceNumberLoading(false);
      });
  };

  const autocompleteNrcInvoiceNumbers = () => {
    setNrcInvoiceNumberLoading(true);
    setLogisticAutocompleteItems('nrcInvoiceNumber').finally(() => {
      setNrcInvoiceNumberLoading(false);
    });
  };

  const autocompleteClientInvoiceNumbers = () => {
    setClientInvoiceNumberLoading(true);
    setLogisticAutocompleteItems('clientInvoiceNumber').finally(() => {
      setClientInvoiceNumberLoading(false);
    });
  };

  const autocompleteCrts = () => {
    setCrtLoading(true);
    setLogisticAutocompleteItems('crt').finally(() => {
      setCrtLoading(false);
    });
  };

  const companyItems = [...new Set([
    ...getLogisticItems('company').map(({ name }) => name),
    ...getLogisticOriginItems('company').map(({ name }) => name),

  ])].map((name, id) => ({ id, name }))

  return (
    <S.Form>
      <S.Body>
        <S.BodyContainer>
          <S.Field>
            <Form.Input.Dropdown
              label="Companhia"
              value={getLogisticFilterField('company') as string}
              onChange={(e) => {
                setLogisticField('company')(e);
                setLogisticOriginField('company')(e);
              }}
              items={companyItems}
              errorMessage={false}
              onSelected={(item) => {
                setLogisticField('company')({
                  target: {
                    value: `${item.name}`,
                  },
                });
                setLogisticOriginField('company')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteCompanies}
              onFocus={() => {
                setLogisticField('company')({
                  target: {
                    value: '',
                  },
                });
                setLogisticOriginField('company')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={companyLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Nota Origem"
              value={getLogisticFilterField('originInvoiceNumber') as string}
              onChange={(e) => {
                setLogisticField('originInvoiceNumber')(e);
                setLogisticOriginField('originInvoiceNumber')(e);
              }}
              items={getLogisticOriginItems('originInvoiceNumber')}
              errorMessage={false}
              onSelected={(item) => {
                setLogisticField('originInvoiceNumber')({
                  target: {
                    value: `${item.name}`,
                  },
                });
                setLogisticOriginField('originInvoiceNumber')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteOriginInvoiceNumbers}
              onFocus={() => {
                setLogisticField('originInvoiceNumber')({
                  target: {
                    value: '',
                  },
                });
                setLogisticOriginField('originInvoiceNumber')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={originInvoiceNumberLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Nota NRC"
              value={getLogisticFilterField('nrcInvoiceNumber') as string}
              onChange={setLogisticField('nrcInvoiceNumber')}
              items={getLogisticItems('nrcInvoiceNumber')}
              errorMessage={false}
              onSelected={(item) => {
                setLogisticField('nrcInvoiceNumber')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteNrcInvoiceNumbers}
              onFocus={() => {
                setLogisticField('nrcInvoiceNumber')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={nrcInvoiceNumberLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Nota Cliente"
              value={getLogisticFilterField('clientInvoiceNumber') as string}
              onChange={setLogisticField('clientInvoiceNumber')}
              items={getLogisticItems('clientInvoiceNumber')}
              errorMessage={false}
              onSelected={(item) => {
                setLogisticField('clientInvoiceNumber')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteClientInvoiceNumbers}
              onFocus={() => {
                setLogisticField('clientInvoiceNumber')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={clientInvoiceNumberLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="CRT"
              value={getLogisticFilterField('crt') as string}
              onChange={setLogisticField('crt')}
              items={getLogisticItems('crt')}
              errorMessage={false}
              onSelected={(item) => {
                setLogisticField('crt')({
                  target: {
                    value: `${item.name}`,
                  },
                });
              }}
              onDebouncedChange={autocompleteCrts}
              onFocus={() => {
                setLogisticField('crt')({
                  target: {
                    value: '',
                  },
                });
              }}
              hasClearItem
              loading={crtLoading}
            />
          </S.Field>

          <S.DateContainer>
            <S.Label>Data Lançamento</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={(getLogisticFilterField('releaseDate', 'GEQ') || getLogisticOriginFilterField('releaseDate', 'GEQ')) as string}
                onChange={(e) => {
                  setLogisticField('releaseDate', 'GEQ')(e);
                  setLogisticOriginField('releaseDate', 'GEQ')(e);
                }}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={(getLogisticFilterField('releaseDate', 'LT') || getLogisticOriginFilterField('releaseDate', 'LT')) as string}
                onChange={(e) => {
                  setLogisticField('releaseDate', 'LT')(e);
                  setLogisticOriginField('releaseDate', 'LT')(e);
                }}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getLogisticFilterField('releaseDate', 'GEQ') as string}
              finalDate={getLogisticFilterField('releaseDate', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filterLogistic = setFilterColumn(
                  'releaseDate',
                  initialDate,
                  logisticSearchFilter,
                  'GEQ',
                );
                filterLogistic = setFilterColumn('releaseDate', finalDate, filterLogistic, 'LT');
                setLogisticSearchFilter(filterLogistic);
                let filterLogisticOrigin = setFilterColumn(
                  'releaseDate',
                  initialDate,
                  logisticOriginSearchFilter,
                  'GEQ',
                );
                filterLogisticOrigin = setFilterColumn('releaseDate', finalDate, filterLogisticOrigin, 'LT');
                setLogisticOriginSearchFilter(filterLogisticOrigin);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Entreposto / Despacho</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getLogisticFilterField('warehouseDispatchDate', 'GEQ') as string}
                onChange={setLogisticField('warehouseDispatchDate', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getLogisticFilterField('warehouseDispatchDate', 'LT') as string}
                onChange={setLogisticField('warehouseDispatchDate', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getLogisticFilterField('warehouseDispatchDate', 'GEQ') as string}
              finalDate={getLogisticFilterField('warehouseDispatchDate', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'warehouseDispatchDate',
                  initialDate,
                  logisticSearchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('warehouseDispatchDate', finalDate, filter, 'LT');
                setLogisticSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Receita</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getLogisticFilterField('revenueDate', 'GEQ') as string}
                onChange={setLogisticField('revenueDate', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getLogisticFilterField('revenueDate', 'LT') as string}
                onChange={setLogisticField('revenueDate', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getLogisticFilterField('revenueDate', 'GEQ') as string}
              finalDate={getLogisticFilterField('revenueDate', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'revenueDate',
                  initialDate,
                  logisticSearchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('revenueDate', finalDate, filter, 'LT');
                setLogisticSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Aduana</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getLogisticFilterField('customsDate', 'GEQ') as string}
                onChange={setLogisticField('customsDate', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getLogisticFilterField('customsDate', 'LT') as string}
                onChange={setLogisticField('customsDate', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getLogisticFilterField('customsDate', 'GEQ') as string}
              finalDate={getLogisticFilterField('customsDate', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'customsDate',
                  initialDate,
                  logisticSearchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('customsDate', finalDate, filter, 'LT');
                setLogisticSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Armazenadora</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getLogisticFilterField('storageDate', 'GEQ') as string}
                onChange={setLogisticField('storageDate', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getLogisticFilterField('storageDate', 'LT') as string}
                onChange={setLogisticField('storageDate', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getLogisticFilterField('storageDate', 'GEQ') as string}
              finalDate={getLogisticFilterField('storageDate', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'storageDate',
                  initialDate,
                  logisticSearchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('storageDate', finalDate, filter, 'LT');
                setLogisticSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Cliente</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getLogisticFilterField('clientDate', 'GEQ') as string}
                onChange={setLogisticField('clientDate', 'GEQ')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getLogisticFilterField('clientDate', 'LT') as string}
                onChange={setLogisticField('clientDate', 'LT')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getLogisticFilterField('clientDate', 'GEQ') as string}
              finalDate={getLogisticFilterField('clientDate', 'LT') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'clientDate',
                  initialDate,
                  logisticSearchFilter,
                  'GEQ',
                );
                filter = setFilterColumn('clientDate', finalDate, filter, 'LT');
                setLogisticSearchFilter(filter);
              }}
            />
          </S.DateContainer>
        </S.BodyContainer>
      </S.Body>
      <S.ClearButton
        onClick={(e) => {
          e.preventDefault();
          setInvoice('filters.logistics.filter.filter', []);
        }}
      >
        Limpar
      </S.ClearButton>
    </S.Form>
  );
}
